const ProfileOverview = () => {
  return <div className="mt-4 flex w-full flex-col gap-5">Profile content</div>;
};

export default ProfileOverview;
